import Model from 'flarum/common/Model';

export default class CreditExchangeRate extends Model {}

Object.assign(CreditExchangeRate.prototype, {
  fromType: Model.attribute('from_type'),
  toType: Model.attribute('to_type'),
  rate: Model.attribute('rate'),
  isActive: Model.attribute('is_active'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),
});
